import PropTypes from "prop-types"

import withRecentlyViewed from "areas/product/hoc/with-recently-viewed"

import { StaticSectionTitle } from "./components"
import ProductsList from "./products-list"

const RecentlyViewed = ({ recentlyViewed }) => {
  if (recentlyViewed.length == 0) {
    return null
  }

  let displayDesktop = recentlyViewed.length > 6 ? "flex" : "none"
  let displayTablet = recentlyViewed.length > 5 ? "flex" : "none"

  return (
    <div className="contained tablet:pl-0 tablet:pt-0 w-full bg-white pb-40 pl-12 pt-1">
      {recentlyViewed.length > 0 && (
        <div>
          <StaticSectionTitle key="matching-title">
            RECENTLY VIEWED
          </StaticSectionTitle>
          <ProductsList
            displayArrows={{
              _: "none",
              desktop: displayDesktop,
              tablet: displayTablet,
            }}
            key="matching-list"
            linkClickData="recently-viewed-product-list"
            products={recentlyViewed}
          />
        </div>
      )}
    </div>
  )
}

RecentlyViewed.propTypes = {
  recentlyViewed: PropTypes.array,
}

export default withRecentlyViewed(RecentlyViewed)
